import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "bg-gray-900 text-white py-5 px-4" };
var _hoisted_2 = { class: "max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 text-sm" };
var _hoisted_3 = { class: "text-center md:text-left" };
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Footer',
    setup: function (__props) {
        var currentYear = ref(new Date().getFullYear());
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("p", null, [
                            _createTextVNode("© " + _toDisplayString(currentYear.value) + " ", 1),
                            _cache[0] || (_cache[0] = _createElementVNode("a", {
                                href: "https://www.rho1and0.net",
                                class: "hover:underline text-indigo-400",
                                target: "_blank",
                                rel: "noopener noreferrer"
                            }, "www.rho1and0.net", -1)),
                            _cache[1] || (_cache[1] = _createTextVNode(". Todos los derechos reservados."))
                        ])
                    ]),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-center md:text-right" }, [
                        _createElementVNode("a", {
                            href: "/politicas-privacidad-y-condiciones-servicio",
                            class: "text-indigo-400 hover:underline"
                        }, " Políticas de Privacidad y Condiciones de Uso ")
                    ], -1))
                ])
            ]));
        };
    }
});
